import { atom } from 'jotai';

export interface AuthenticatedUser {
  authenticated: boolean;
  username: string;
  fullName: string;
  orgId: string;
  appInfo: { orgId: string };
  groups: Array<{ id: string; title: string }>;
}

export const userAtom = atom<AuthenticatedUser | null>(null);
